export default __webpack_public_path__ + "static/CSICon 2022 Promo Vid-3-7346d0179be95378b4a9b31169fc0df7.mp4";